import { combineReducers } from '@reduxjs/toolkit';
import { authReducers } from '@/modules/auth';
import { subscriptionReducers } from '@/modules/subscription';
import { globalLoadingReducer } from './slices/global-loading-slice';
import { toastReducer } from './slices/toast-slice';

export const rootReducer = combineReducers({
  auth: authReducers,
  subscription: subscriptionReducers,
  globalLoading: globalLoadingReducer,
  toast: toastReducer,
});
